import React from "react";

const Roadmap = () => {
  return (
    <div className="section-container" id="roadmap">
      <h3 className="section-title">Roadmap</h3>
      {/* 0% Mint goes live and we pay back our hungry designers */}
      {/* 20% Special NFTs to be airdropped to propituous anubis holders */}
      {/* 40% Anubis holders get access to the Official God of the Dead's merch collection and goodies */}
      {/* 60% We partner up with social media and crypto influencers to take the project and the community to greater heights */}
      {/* 80% The anubis community will be invited for the first Anubis Party which will include Egyptian Heqet and a royal feast 
          If covid continues, we will have this as an online event (first of many events to come in future)*/}
      {/* 100% We have maintained a 10% royalty on this project and every month this will be used for community exclusive events and parties
          If events are not possible due to COVID, we will be sure to donate the proceedings to various charities. */}
      <div className="flex flex-none flex-col items-center justify-around">
        <div className="roadmap-card-div">
          <p className="roadmap-card-content text-center w-9/12 md:w-[32rem] text-base md:text-2xl pb-2">
            Mint goes live and we pay back our hungry designers
          </p>
        </div>
        <div className="roadmap-card-div">
          <p className="roadmap-card-content text-center w-9/12 md:w-[32rem] text-base md:text-2xl pb-2">
            Special NFTs to be airdropped to propituous Anubis holders
          </p>
        </div>
        <div className="roadmap-card-div">
          <p className="roadmap-card-content text-center w-9/12 md:w-[32rem] text-base md:text-2xl pb-2">
            Anubis holders get access to the Official God of the Dead's merch
            collection and goodies
          </p>
        </div>
        <div className="roadmap-card-div">
          <p className="roadmap-card-content text-center w-9/12 md:w-[32rem] text-base md:text-2xl pb-2">
            We partner up with social media and crypto influencers to take the
            project and the community to greater heights
          </p>
        </div>
        <div className="roadmap-card-div">
          <p className="roadmap-card-content text-center w-9/12 md:w-[32rem] text-xs md:text-lg pb-2">
            The Anubis community will be invited for the first Anubis Party
            which will include Egyptian Heqet and a royal feast If covid
            continues, we will have this as an online event (first of many
            events to come in future)
          </p>
        </div>
        <div className="roadmap-card-div">
          <p className="roadmap-card-content text-center w-9/12 md:w-[32rem] text-xs md:text-lg pb-2">
            We have maintained a 10% royalty on this project and every month
            this will be used for community exclusive events and parties If
            events are not possible due to COVID, we will be sure to donate the
            proceedings to various charities.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Roadmap;
